import { Box, Button, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzAutoCompleteSingleSelectInput from '../../../components/BuzzAutoCompleteInput/BuzzAutoCompleteSingleSelectInput';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeUserIdentityPassword,
  getUserIdentityList,
} from '../ManagementStore/ManagementStoreSlice';
import useToast from '../../../hooks/useToast';
import { Alert } from '@material-ui/lab';

function changePassword() {
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();

  const { users } = useSelector(({ managementStoreReducer }) => {
    return {
      users: managementStoreReducer.userIdentityList.data || [],
    };
  });

  useEffect(() => {
    dispatch(getUserIdentityList());
  }, []);

  const userOptions = useMemo(() => {
    return users.map(({ _id, name, email, phone }) => {
      return {
        label: `${name ? name + ' |' : ''} ${email} ${
          phone ? '| ' + phone : ''
        }`,
        value: _id,
      };
    });
  }, [users]);

  const [selectedUserId, setSelectedUserId] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const isPasswordStrong = useMemo(() => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._-]).{8,}$/;

    return regex.test(newPassword);
  }, [newPassword]);

  const handleSave = () => {
    dispatch(
      changeUserIdentityPassword({
        identityId: selectedUserId,
        newPassword,
      })
    )
      .unwrap()
      .then((res) => {
        SuccessToast('Password updated successfully!');
        setNewPassword('');
        setSelectedUserId('');
      })
      .catch((err) => {
        ErrorToast('Failed to update password!');
      });
  };

  return (
    <Box>
      <p style={{ fontSize: '1.5rem', fontWeight: 500 }}>Change Password</p>

      <Box
        display={'flex'}
        flexDirection={'column'}
        // alignItems={'center'}
        style={{ gap: '1rem' }}
        maxWidth={'600px'}>
        <BuzzAutoCompleteSingleSelectInput
          id={'userId'}
          label={'User'}
          options={userOptions}
          value={selectedUserId}
          onChange={(value) => setSelectedUserId(value)}
          required={true}
        />
        <BuzzInput
          size="small"
          type="text"
          label={'New Password'}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={!selectedUserId}
        />
        <p>
          {newPassword && !isPasswordStrong && (
            <Alert severity="warning">
              <Typography>
                Password must be at least 8 characters long and include
                uppercase, lowercase, number, and special character.
              </Typography>
            </Alert>
          )}
        </p>
        <Box mt={2} maxWidth={'250px'}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={!selectedUserId || !newPassword || !isPasswordStrong}
            onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default changePassword;
